
import { isEmpty, isNullOrUndefined } from '../../../store/storeFunctions';
import { string as YupString } from '../../common/Yup';
import { dataCorrectionSection, repiSearchRegexps } from '../../../store/repiStore';

// Do not return Yup object().shape()!
export function getSubjectDataSchema(section, translate, subjectType) {
    const msgDate = translate("Repi.Error.Validation.DataCorrection.Date");
    const maxLength = translate("Repi.Error.Validation.MaxLength");
    const error975 = translate("Repi.Error.Validation.DataCorrection.Error975");
    const warning975S = translate("Repi.Error.Validation.DataCorrection.Warning975S");
    const warning975E = translate("Repi.Error.Validation.DataCorrection.Warning975E");

    switch (section) {
        case dataCorrectionSection.identification:
            if (isNullOrUndefined(subjectType))
                throw new Error("Paramater 'subjectType' can't be null or undefined");
            const msgCompanyId = translate("Repi.Error.Validation.DataCorrection.CompanyId");
            const msgPin = translate("Repi.Error.Validation.DataCorrection.Pin");
            const error922 = translate("Repi.Error.Validation.DataCorrection.Error922");
            const error923 = translate("Repi.Error.Validation.DataCorrection.Error923");
            const error924 = translate("Repi.Error.Validation.DataCorrection.Error924");
            return {
                birthDate: YupString().typeError(msgDate).test("date", msgDate, v => v === "" || v.toString().match(/^\d{4}-\d{2}-\d{2}/)),
                pin: YupString()
                    .test("pin", msgPin, v => v === "" || v.toString().match(/^\d{2}(0[1-9]|1[0-2]|5[1-9]|6[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])\/?\d{3,4}$/)),
                companyId: YupString()
                    .test("companyId", msgCompanyId, v => v === "" || v.toString().match(/^\d{8}$/))
                    .test("924", error924, v => subjectType === 1 || (subjectType !== 1 && !isEmpty(v))),
                name: YupString().test("922", error922, v => subjectType !== 1 || (subjectType === 1 && !isEmpty(v))),
                surname: YupString().test("923", error923, v => subjectType !== 1 || (subjectType === 1 && !isEmpty(v)))
            };
        case dataCorrectionSection.addresses:
            const msgHouseNo = translate("Repi.Error.Validation.DataCorrection.HouseNo");
            const msgZip = translate("Repi.Error.Validation.DataCorrection.Zip");
            const error926 = translate("Repi.Error.Validation.DataCorrection.Error926");
            const warning972 = translate("Repi.Error.Validation.DataCorrection.Warning972");
            const warning973 = translate("Repi.Error.Validation.DataCorrection.Warning973");
            const warning974 = translate("Repi.Error.Validation.DataCorrection.Warning974");
            return {
                city: YupString().test("926", error926, v => !isEmpty(v)),
                street: YupString().test("972", { message: warning972, isWarning: true }, v => !isEmpty(v)),
                houseNo: YupString().test("houseNo", msgHouseNo, v => v === "" || v.toString().match(/^\d+(\/\d+)?$/))
                    .test("973", { message: warning973, isWarning: true }, v => !isEmpty(v)),
                zip: YupString()
                    .test("zip", msgZip, v => v === "" || v.toString().match(/^((\d{5})|(\d{3}\s\d{2}))$/))
                    .test("974", { message: warning974, isWarning: true }, v => !isEmpty(v)),
                startDate: YupString().typeError(msgDate)
                    .test("date", msgDate, v => v === "" || v.toString().match(/^\d{4}-\d{2}-\d{2}/))
                    .test("975ws", { message: warning975S, isWarning: true }, v => isEmpty(v) || isNaN(Date.parse(v)) || Date.parse(v) <= new Date())
                    .test("975e", error975, function (v) {
                        const start = Date.parse(v);
                        const end = Date.parse(this.parent.endDate);
                        return isNaN(start) || isNaN(end) || start < end;
                    }),
                endDate: YupString().typeError(msgDate)
                    .test("date", msgDate, v => v === "" || v.toString().match(/^\d{4}-\d{2}-\d{2}/))
                    .test("975we", { message: warning975E, isWarning: true }, v => isEmpty(v) || isNaN(Date.parse(v)) || Date.parse(v) <= new Date())
                    .test("975e", error975, function (v) {
                        const start = Date.parse(this.parent.startDate);
                        const end = Date.parse(v);
                        return isNaN(start) || isNaN(end) || start < end;
                    })
                };
        case dataCorrectionSection.contacts:
            const msgValueFormat = translate("Repi.Error.Validation.DataCorrection.ContactFormat");
            const error931 = translate("Repi.Error.Validation.DataCorrection.Error931");
            return {
                startDate: YupString().typeError(msgDate)
                    .test("date", msgDate, v => v === "" || v.toString().match(/^\d{4}-\d{2}-\d{2}/))
                    .test("975ws", { message: warning975S, isWarning: true }, v => isEmpty(v) || isNaN(Date.parse(v)) || Date.parse(v) <= new Date())
                    .test("975e", error975, function (v) {
                        const start = Date.parse(v);
                        const end = Date.parse(this.parent.endDate);
                        return isNaN(start) || isNaN(end) || start < end;
                    }),
                endDate: YupString().typeError(msgDate)
                    .test("date", msgDate, v => v === "" || v.toString().match(/^\d{4}-\d{2}-\d{2}/))
                    .test("975we", { message: warning975E, isWarning: true }, v => isEmpty(v) || isNaN(Date.parse(v)) || Date.parse(v) <= new Date())
                    .test("975e", error975, function (v) {
                        const start = Date.parse(this.parent.startDate);
                        const end = Date.parse(v);
                        return isNaN(start) || isNaN(end) || start < end;
                    }),
                value: YupString().typeError(msgValueFormat)
                    .test("931", error931, v => !isEmpty(v))
                    .test("value", msgValueFormat, function (v) {
                        return isEmpty(v) || this.parent.contactType === 0 ||
                            this.parent.contactType === 1 && v.toString().match(repiSearchRegexps.phone) ||
                            this.parent.contactType === 2 && v.toString().match(repiSearchRegexps.email) ||
                            this.parent.contactType === 3 && (v.toString().match(repiSearchRegexps.ipv4) || v.toString().match(repiSearchRegexps.ipv6))
                    })
            };
        case dataCorrectionSection.documents:
            const error929 = translate("Repi.Error.Validation.DataCorrection.Error929");
            const warning976I = translate("Repi.Error.Validation.DataCorrection.Warning976I");
            const warning976E = translate("Repi.Error.Validation.DataCorrection.Warning976E");
            const warning977 = translate("Repi.Error.Validation.DataCorrection.Warning977");
            return {
                issueDate: YupString().typeError(msgDate)
                    .test("date", msgDate, v => v === "" || v.toString().match(/^\d{4}-\d{2}-\d{2}/))
                    .test("976i", { message: warning976I, isWarning: true }, v => isEmpty(v) || isNaN(Date.parse(v)) || Date.parse(v) <= new Date())
                    .test("977", { message: warning977, isWarning: true }, function (v) {
                        const issue = Date.parse(v);
                        const expire = Date.parse(this.parent.expirationDate);
                        return isNaN(issue) || isNaN(expire) || issue < expire;
                    }),
                expirationDate: YupString().typeError(msgDate)
                    .test("date", msgDate, v => v === "" || v.toString().match(/^\d{4}-\d{2}-\d{2}/))
                    .test("976e", { message: warning976E, isWarning: true }, v => isEmpty(v) || Date.parse(v) > new Date(2000, 1, 1))
                    .test("977", { message: warning977, isWarning: true }, function (v) {
                        const issue = Date.parse(this.parent.issueDate);
                        const expire = Date.parse(v);
                        return isNaN(issue) || isNaN(expire) || issue < expire;
                    }),
                startDate: YupString().typeError(msgDate)
                    .test("date", msgDate, v => v === "" || v.toString().match(/^\d{4}-\d{2}-\d{2}/))
                    .test("975ws", { message: warning975S, isWarning: true }, v => isEmpty(v) || isNaN(Date.parse(v)) || Date.parse(v) <= new Date())
                    .test("975e", error975, function (v) {
                        const start = Date.parse(v);
                        const end = Date.parse(this.parent.endDate);
                        return isNaN(start) || isNaN(end) || start < end;
                    }),
                endDate: YupString().typeError(msgDate)
                    .test("date", msgDate, v => v === "" || v.toString().match(/^\d{4}-\d{2}-\d{2}/))
                    .test("975we", { message: warning975E, isWarning: true }, v => isEmpty(v) || isNaN(Date.parse(v)) || Date.parse(v) <= new Date())
                    .test("975e", error975, function (v) {
                        const start = Date.parse(this.parent.startDate);
                        const end = Date.parse(v);
                        return isNaN(start) || isNaN(end) || start < end;
                    }),
                value: YupString()
                    .max(20, maxLength.replace("${length}", 20))
                    .test("929", error929, v => !isEmpty(v))
            };
        default:
            return {};
    }
}